import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/Common/Loader';
import { setStopLoadUpdates } from '../../../store/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { autoFetchUserDetails } from '../../../store/thunks/user.thunk';
import { CONFIG } from '../../../config/mainConfig';
import { getUserAuthSession } from './SignUp/SignUp.service';
import { autoSubscribeOnThePlan, autoSubscribeOnThePlanFromInvitationToken } from '../services/auth.service';
import { UserLocalStorageKeysEnum } from '../../../interfaces/user.interface';
import { TokenCookieManager } from '../../../utils/tokenCookies';
import { getURLSearchParams } from '../../../helper/helper';

const BuilderInit = () => {
  const searchParams = getURLSearchParams();
  const dispatch: AppDispatch = useDispatch();
  const navigateTo = useNavigate();
  const [fetchingUserDataAndAutoSubscribe, setFetchingUserDataAndAutoSubscribe] = useState<boolean>(false);
  const [tryToSubscribeFromInvitation, setTryToSubscribeFromInvitation] = useState<boolean>(false);
  const user = useSelector((state: RootState) => state.user.user);
  const userAuthorized = useSelector((state: RootState) => state.user.userAuthorized);

  useEffect(() => {
    console.log(userAuthorized);
    if (userAuthorized !== null && !userAuthorized) {
      navigateTo('/auth');
    }
  }, [userAuthorized]);

  useEffect(() => {
    const stopLoadUpdates = !!searchParams.get(CONFIG.HEADERS.SUBSCRIBE_PLAN_ID);
    if (stopLoadUpdates) {
      dispatch(setStopLoadUpdates(true));
    }

    return () => {
      stopLoadUpdates && dispatch(setStopLoadUpdates(false));
    };
  }, []);

  const autoSubscribeOnPlanOrInvite = async (): Promise<void> => {
    const planId = searchParams.get(CONFIG.HEADERS.SUBSCRIBE_PLAN_ID);
    const currencyCode = searchParams.get(CONFIG.HEADERS.CURRENCY);
    // const inviteAccessToken = searchParams.get(CONFIG.HEADERS.INVITE_ACCESS_KEY);
    const user = await getUserAuthSession();

    if (!user) {
      TokenCookieManager.removeToken();
      localStorage.removeItem(UserLocalStorageKeysEnum.CURRENT_USER);
      return;
    }

    if (planId) {
      if (user?.email) {
        autoSubscribeOnThePlan(planId, currencyCode, user, dispatch, navigateTo, () => {});
      } else {
        setFetchingUserDataAndAutoSubscribe(true);
        dispatch(autoFetchUserDetails());
      }
    }
  };

  useEffect(() => {
    if (!TokenCookieManager.hasToken()) {
      return;
    }
    autoSubscribeOnPlanOrInvite().then().catch();
    return () => {};
  }, []);

  useEffect(() => {
    if (!user?.email) {
      return;
    }
    if (fetchingUserDataAndAutoSubscribe) {
      const currencyCode = searchParams.get(CONFIG.HEADERS.CURRENCY);
      setFetchingUserDataAndAutoSubscribe(false);
      autoSubscribeOnThePlan(
        searchParams.get(CONFIG.HEADERS.SUBSCRIBE_PLAN_ID)!,
        currencyCode,
        user,
        dispatch,
        navigateTo,
        () => {},
      );
    } else if (tryToSubscribeFromInvitation) {
      if (!user.plan) {
        setTryToSubscribeFromInvitation(false);
        autoSubscribeOnThePlanFromInvitationToken(
          searchParams.get(CONFIG.HEADERS.INVITE_ACCESS_KEY)!,
          user,
          dispatch,
          navigateTo,
          () => {},
        );
      } else {
        navigateTo('/');
      }
    }
  }, [user]);

  return (
    <>
      <div className="flex justify-center items-center">
        <Loader loader={true} />
      </div>
    </>
  );
};

export default BuilderInit;
